import { LinearProgress } from '@hyperflake/react-ui-library';
import { BackButton } from '@library/buttons';
import useClientInstallationData from 'modules/client-installation/hooks/useClientInstallationData';
import AddProjectInstallationForm from 'modules/project-installation/components/AddProjectInstallationForm/AddProjectInstallationForm';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { useParams } from 'react-router-dom';

const AddProjectInstallationPage = () => {
    const { clientInstallationId } = useParams();
    const { clientInstallation, isLoading, setData } = useClientInstallationData(clientInstallationId);
    return (
        <PageTemplate>
            <BackButton />
            <PageHeading>
                <div className="flex gap-2">Add Project For Installation</div>
            </PageHeading>

            {isLoading ? (
                <>
                    <LinearProgress />
                </>
            ) : (
                <div>
                    <AddProjectInstallationForm clientInstallation={clientInstallation} />
                </div>
            )}
        </PageTemplate>
    );
};

export default AddProjectInstallationPage;
